import { useContext } from 'react';
import { TextField, Autocomplete, Box, Typography } from "@mui/material";
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { addOrdersContext } from './AddOrdersContext';
import Moment from 'react-moment';


let AddOrders = () => {
    let { formatMessage } = useIntl();

    let service = useContext(addOrdersContext);


    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            loading={service.isLoading}
            value={service.selectedRowIds}
            isOptionEqualToValue={(option, value) => option === value}
            options={service.workOrders.map(x => x.workOrderId)}
            getOptionLabel={(option) => {
                let workOrder = service.workOrders.find(x => x.workOrderId === option);

                return workOrder?.workOrderNumber !== ''
                    ? `${workOrder?.workOrderNumber} - ${workOrder?.articleDescription}`
                    : workOrder?.articleDescription;
            }}
            renderOption={(props, option) => {
                let workOrder = service.workOrders.find(x => x.workOrderId === option);

                return (
                    <li {...props}>
                        <Box sx={{ flexGrow: 1 }}>
                            {workOrder?.workOrderNumber !== '' && <><Box component="b">{workOrder?.workOrderNumber}</Box>&nbsp;</>}
                            {workOrder?.orderNumber !== '' && <i>Ordine&nbsp;{workOrder?.orderNumber}&nbsp;del&nbsp;<Moment date={workOrder?.orderDate} format="LL" /></i>}
                            <Typography>{workOrder?.articleId}&nbsp;{workOrder?.articleModel}&nbsp;{workOrder?.articleDescription}</Typography>
                        </Box>
                    </li>
                )
            }}
            onChange={(e, newValue) => {
                let workOrders = service.workOrders.filter(x => newValue.indexOf(x.workOrderId) !== -1);
                service.selectWorkOrders(workOrders);
            }}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label={formatMessage({ id: LocalizationIds.WorkOrders })}
                />
            }
        />
    )
}

export default AddOrders;